<template>
  <v-system-bar
    v-if="entity?.availableUntil"
    class="text-body-2"
    :color="entity?.isDemoAccount ? undefined : 'primary'"
    :height
    order="-1"
  >
    <v-container class="text-center">
      {{ t('messages.accountWillBeDeletedAfter', { date: format(entity.availableUntil) }) }}
      <v-btn
        v-if="needs('OWNER') && !entity.isDemoAccount"
        class="ml-4"
        :prepend-icon="mdiAccountReactivateOutline"
        size="small"
        :text="`${t('messages.account')} - ${t('messages.setting')}`"
        :to="{name: 'settings-ownership'}"
      />
    </v-container>
  </v-system-bar>
</template>

<script lang="ts" setup>
import { mdiAccountReactivateOutline } from '@mdi/js';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useCurrentAccountStore } from '@abaninja/data-access-swiss21-account';
import { useAccountRoleStore } from '@abaninja/data-access-swiss21-users';
import { useDateTimeFormatter } from '@abaninja/util-formatters';

const currentAccountStore = useCurrentAccountStore();

const { entity } = storeToRefs(currentAccountStore);

const { format } = useDateTimeFormatter();

const { t } = useI18n();

const { needs } = useAccountRoleStore();

const height = computed(() => needs('ADMIN') ? 48 : 36);
</script>
